import { Injectable } from '@angular/core';
import { AuthConsoleLoginDTO, AuthConsoleLoginByTokenDTO } from '@core/models/dto/auth-console.dto';
import { API_ENDPOINT, TOKEN_API_ENDPOINT } from '@core/configs';
import { ApiService } from './common/api.service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthConsoleService {
  constructor(private readonly http: ApiService) { }
  login(body: AuthConsoleLoginDTO) {
    // return this.http.post(API_ENDPOINT.authConsole.login, body);
    return this.http.post(API_ENDPOINT.authConsole.login, body);
  }

  loginByToken(body: AuthConsoleLoginByTokenDTO) {
    return this.http.post(API_ENDPOINT.authConsole.loginByToken, body);
  }
}
